import { NgModule } from '@angular/core';
// import { CKEditorModule } from 'ng2-ckeditor';


import { SharedModule } from '../shared/shared.module';

import { AddExperienceComponent } from './components/add-experience/add-experience.component';
import { AddEducationComponent } from './components/add-education/add-education.component';
import { AddSkillsComponent } from './components/add-skills/add-skills.component';
import { AddLanguagesComponent } from './components/add-languages/add-languages.component';

import { ResumeRoutingModule } from './resume-routing.module';
import { AddOptionsComponent } from './components/add-options/add-options.component';
import { AddPaymentComponent } from './components/add-payment/add-payment.component';
import { AddSummaryComponent } from './components/add-summary/add-summary.component';
import { AddCertificatesComponent } from './components/add-certificates/add-certificates.component';
import { AddAccomplishmentsComponent } from './components/add-accomplishments/add-accomplishments.component';
import { AddHobbiesComponent } from './components/add-hobbies/add-hobbies.component';
import { AddOthersComponent } from './components/add-others/add-others.component';
import { AddProjectsComponent } from './components/add-projects/add-projects.component';
import { ResumeInfoComponent } from './components/resume-info/resume-info.component';

import { ResumeService } from './services/resume.service';
import { DonateComponent } from './components/donate/donate.component';

@NgModule({
  imports: [
    SharedModule,
    ResumeRoutingModule
  ],
  declarations: [
    AddExperienceComponent,
    AddEducationComponent,
    AddSkillsComponent,
    AddLanguagesComponent,
    AddOptionsComponent,
    AddPaymentComponent,
    AddSummaryComponent,
    AddCertificatesComponent,
    AddAccomplishmentsComponent,
    AddHobbiesComponent,
    AddOthersComponent,
    ResumeInfoComponent,
    AddProjectsComponent,
    DonateComponent
  ],
  providers: [
    ResumeService
  ]
})
export class ResumeModule {}
